import FooterHeading from './HeadingFooter'

export default FooterHeading
